module.exports = __webpack_public_path__ + "img/Artboard – 1 (6).bd6afa7a.png";